export default function LocationsHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden bg-[#0A0A0A]">
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center scale-105"
        style={{
          backgroundImage: "url('https://public.readdy.ai/ai/img_res/438273d95ae530237cee6b4df40fd49f.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/96 via-[#0A0A0A]/90 to-[#0A0A0A]/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/80 via-transparent to-[#050505]/40" />
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-transparent via-[#FF6B35] to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-44 pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-3 mb-8">
              <span className="inline-flex items-center gap-2 border border-[#FF6B35]/50 bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-black uppercase tracking-widest px-4 py-2 rounded-full">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-2-fill text-xs" /></span>
                South Windsor, CT
              </span>
              <span className="inline-flex items-center gap-2 border border-white/15 text-white/60 text-xs font-semibold px-4 py-2 rounded-full">
                Hartford County
              </span>
            </div>

            <h1 className="font-display font-black leading-[1.02] mb-6">
              <span className="block text-white" style={{ fontSize: 'clamp(2rem, 4vw, 3.8rem)' }}>
                Serving South Windsor &amp;
              </span>
              <span className="block text-[#FF6B35]" style={{ fontSize: 'clamp(2.2rem, 4.5vw, 4.2rem)' }}>
                All of Hartford County
              </span>
              <span className="block text-white" style={{ fontSize: 'clamp(1.6rem, 3.2vw, 2.8rem)' }}>
                with Premium Auto Protection
              </span>
            </h1>

            <p className="text-white/80 text-lg leading-relaxed mb-2 max-w-xl">
              DBN Garage is South Windsor's only XPEL-certified auto protection studio — conveniently located to serve all of Hartford County, CT.
            </p>
            <p className="text-white/50 text-base mb-10 max-w-lg">
              PPF · Ceramic Coating · Window Tint · Matte Wraps — available to vehicle owners across Manchester, Glastonbury, West Hartford, Hartford, and beyond.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <a href="#lead-form"
                className="flex items-center justify-center gap-3 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-black text-base px-9 py-4 rounded-xl transition-all hover:scale-[1.02] whitespace-nowrap cursor-pointer"
                style={{ boxShadow: '0 10px 30px rgba(255,107,53,0.35)' }}>
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill text-lg" /></span>
                Book Your Appointment
              </a>
              <a href="tel:+18605550127"
                className="flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white/70 hover:bg-white/10 text-white font-bold text-base px-8 py-4 rounded-xl transition-all whitespace-nowrap cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
                (860) 555-0127
              </a>
            </div>

            <div className="flex flex-wrap gap-x-8 gap-y-3">
              {[
                { icon: 'ri-map-pin-2-fill', text: 'South Windsor, CT' },
                { icon: 'ri-award-fill', text: 'XPEL Certified' },
                { icon: 'ri-car-fill', text: 'Serving All Hartford County' },
                { icon: 'ri-star-fill', text: '5★ Local Rating' },
              ].map((b) => (
                <div key={b.text} className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center"><i className={`${b.icon} text-[#FF6B35] text-sm`} /></span>
                  <span className="text-white/65 text-sm font-medium whitespace-nowrap">{b.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 hidden lg:flex flex-col gap-4">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-[#FF6B35]/15 rounded-xl">
                  <i className="ri-map-pin-2-fill text-[#FF6B35] text-base" />
                </div>
                <div>
                  <p className="text-white font-bold text-sm">DBN Garage</p>
                  <p className="text-gray-500 text-xs">South Windsor, CT 06074</p>
                </div>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed mb-4">
                By-appointment studio serving all of Hartford County. Free consultations available. Same-week scheduling for most services.
              </p>
              <a href="tel:+18605550127" className="flex items-center gap-2 text-[#FF6B35] font-bold text-sm cursor-pointer">
                <i className="ri-phone-fill" /> (860) 555-0127
              </a>
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: 'ri-time-fill', label: 'Mon–Sat', sub: 'By Appointment' },
                { icon: 'ri-map-pin-fill', label: 'South Windsor', sub: 'Hartford County, CT' },
                { icon: 'ri-car-fill', label: '20+ Cities', sub: 'Served Locally' },
                { icon: 'ri-shield-star-fill', label: 'Lifetime', sub: 'Warranty Options' },
              ].map((s) => (
                <div key={s.label} className="bg-white/5 border border-white/10 rounded-xl px-4 py-3 flex items-center gap-3">
                  <span className="w-7 h-7 flex items-center justify-center bg-[#FF6B35]/15 rounded-lg flex-shrink-0">
                    <i className={`${s.icon} text-[#FF6B35] text-sm`} />
                  </span>
                  <div>
                    <p className="text-white/80 text-xs font-bold">{s.label}</p>
                    <p className="text-white/40 text-xs">{s.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 text-white/25 animate-bounce">
        <span className="text-xs uppercase tracking-[0.2em]">Explore</span>
        <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-line" /></span>
      </div>
    </section>
  );
}
